import { useContext } from "react";
import { RoomContext } from "./RoomContext";

export function useDisplayName() {
  const ctx = useContext(RoomContext);
  if (!ctx) throw new Error("useDisplayName must be used within RoomProvider");
  return {
    displayName: ctx.editedName || ctx.generatedName,
    placeholder: ctx.generatedName,
    edited: ctx.editedName,
    setDisplayName: ctx.setEditedName,
  };
}
